module.exports = "/_next/static/images/922f015bc3003cc33482b76541d56a63-pj-man-holding-business-card@3x.jpg";